import { costByAdType } from '../../constants/adTypeCost'

const parseCurrencyValue: ParseCurrencyValue = (value, lengthCentsCurrency) => {
  if (!value) return null
  const numberValue = Number(value)
  return lengthCentsCurrency ? numberValue / 100 : numberValue
}

// Cost by type

const applyCostSettingsByAdType: ApplyCostSettingsByAdType = (
  adType,
  CPC,
  CPM,
  lengthCentsCurrency
) => {
  const handleValue: ApplyCostSettingsByAdTypeHandleValue = value => {
    if (value === null || value === undefined) return null
    return parseCurrencyValue(value.toString(), lengthCentsCurrency)
  }

  const costs: ApplyCostSettingsByAdTypeCosts = {}

  const isCPCSupported = costByAdType.cpc.includes(adType)
  const isCPMSupported = costByAdType.cpm.includes(adType)

  // Se o tipo não está em nenhum array conhecido, retorna ambos como fallback
  const isUnknownType = !isCPCSupported && !isCPMSupported

  const shouldAssignCPC = (isCPCSupported || isUnknownType) && CPC !== undefined
  const shouldAssignCPM = (isCPMSupported || isUnknownType) && CPM !== undefined

  if (shouldAssignCPC) {
    costs.cpc = handleValue(CPC)
  }
  if (shouldAssignCPM) {
    costs.cpm = handleValue(CPM)
  }

  return costs
}

export { applyCostSettingsByAdType, parseCurrencyValue }
